var map = {
	"./echart0_icon.svg": "vBHT",
	"./echart10_icon.svg": "MXEx",
	"./echart11_icon.svg": "T/LT",
	"./echart12_icon.svg": "G1Cv",
	"./echart13_icon.svg": "F5yc",
	"./echart14_icon.svg": "DqT8",
	"./echart1_icon.svg": "YRhD",
	"./echart2_icon.svg": "t/i8",
	"./echart3_icon.svg": "SA2b",
	"./echart4_icon.svg": "4HAJ",
	"./echart5_icon.svg": "hmQk",
	"./echart6_icon.svg": "q/Xz",
	"./echart7_icon.svg": "pFR7",
	"./echart8_icon.svg": "Clxw",
	"./echart9_icon.svg": "22ua"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Wntz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/test ^\.\/echart.*_icon\.svg$
// module id = Wntz
// module chunks = 4